// A production day (a movement, a count, a schedule, a forecast day, an NC...) is a
// calendar day with no time, carried as 'YYYY-MM-DD' everywhere so it reads the same in
// every timezone.
//
// What the API sends for a day:
// - Postgres `date` columns as a UTC-midnight timestamp, '2026-10-12T00:00:00.000Z'
//   (gps-api runs in UTC);
// - text columns and the forecast engine's days as a plain '2026-10-12'.
// Both carry the stored day in their first 10 characters. Never read them with
// new Date(value) followed by a local-time method (toLocaleDateString, getDate, getDay):
// both forms parse as UTC midnight, which is the previous day west of UTC.
//
// What the API expects: 'YYYY-MM-DD', never a Date (axios sends a Date as UTC, which
// moves a local-midnight date to the previous day east of UTC).

// The 'YYYY-MM-DD' of a day sent by the API. A Date can only come from the page itself
// (a picker, a loop over local days), so it is read as the user's own day.
export function dayKey (value) {
  if (value instanceof Date) {
    return localDayKey(value)
  }
  return String(value).slice(0, 10)
}

// The 'YYYY-MM-DD' of a local Date (a datepicker value, now): the user's own calendar day.
export function localDayKey (date) {
  return date.toLocaleDateString('en-CA')
}

// Local midnight of a day, for datepickers, labels and day arithmetic (setDate, getDay).
export function dayToLocalDate (value) {
  const [year, month, day] = dayKey(value).split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function todayKey () {
  return localDayKey(new Date())
}

// Local midnight today, the default of a date field.
export function today () {
  return dayToLocalDate(todayKey())
}
